var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertActive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.836 6.712a2.164 2.164 0 1 0 0-4.328 2.164 2.164 0 0 0 0 4.328Z",
    stroke: "url(#paint0_linear_916_6124_2)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.802 16.034a1.506 1.506 0 0 0 2.89 0M8.245 2.508V.885m5.427 8.088c.136 4.152 1.065 4.897 1.065 4.897H1.752s1.082-1.382 1.082-5.951A5.415 5.415 0 0 1 9.85 2.75",
    stroke: "#AFB2B6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_6124_2",
    x1: 11.779,
    y1: 0.827,
    x2: 16.236,
    y2: 1.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertActive2);
export default __webpack_public_path__ + "static/media/alertActive2.9fe26e2ba344fe70d3f3b6c41aa1e95d.svg";
export { ForwardRef as ReactComponent };